// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Uuid = require("uuid");
var $$Array = require("rescript/lib/js/array.js");
var Decco = require("decco/src/Decco.bs.js");
var React = require("react");
var $$String = require("rescript/lib/js/string.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var Belt_MapInt = require("rescript/lib/js/belt_MapInt.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_module = require("rescript/lib/js/caml_module.js");
var Belt_MapString = require("rescript/lib/js/belt_MapString.js");
var Util$SmartcutsMacros = require("../../../../bs-utils/src/Util.bs.js");
var Image$SmartcutsMacros = require("../../Image.bs.js");
var Clipboard$SmartcutsMacros = require("../../Clipboard.bs.js");
var CustomMap$SmartcutsMacros = require("../../CustomMap.bs.js");
var ArrayUtils$SmartcutsMacros = require("../../../../bs-utils/src/ArrayUtils.bs.js");
var ReactUtils$SmartcutsMacros = require("../../../../bs-utils/src/ReactUtils.bs.js");
var RegExUtils$SmartcutsMacros = require("../../../../bs-utils/src/RegExUtils.bs.js");
var OptionUtils$SmartcutsMacros = require("../../../../bs-utils/src/OptionUtils.bs.js");
var StringUtils$SmartcutsMacros = require("../../../../bs-utils/src/StringUtils.bs.js");
var TextEditing$SmartcutsMacros = require("../../TextEditing.bs.js");
var CommandContext$SmartcutsMacros = require("../../CommandContext.bs.js");
var Selection__StrictSelection$SmartcutsMacros = require("../../Selection/Selection__StrictSelection.bs.js");

function t_encode(v) {
  return Js_dict.fromArray([
              [
                "commandId",
                Decco.intToJson(v.commandId)
              ],
              [
                "commandInfo",
                v.commandInfo
              ],
              [
                "text",
                Decco.stringToJson(v.text)
              ]
            ]);
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var commandId = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "commandId"), null));
  if (commandId.TAG === /* Ok */0) {
    var commandInfo = {
      TAG: /* Ok */0,
      _0: Belt_Option.getWithDefault(Js_dict.get(dict$1, "commandInfo"), null)
    };
    if (commandInfo.TAG === /* Ok */0) {
      var text = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "text"), null));
      if (text.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  commandId: commandId._0,
                  commandInfo: commandInfo._0,
                  text: text._0
                }
              };
      }
      var e = text._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".text" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = commandInfo._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".commandInfo" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = commandId._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".commandId" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function stringify(param) {
  return "{commandId: " + (String(param.commandId) + (", text: " + (StringUtils$SmartcutsMacros.quote(param.text) + ")")));
}

function applyClipboard(textFromCommand, clipboardContentByCommandLogIndex) {
  var commandId = textFromCommand.commandId;
  var arg = Belt_MapInt.get(clipboardContentByCommandLogIndex, commandId);
  var clipboardContent = (function (param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg);
      })("Expected text to be copied by command " + String(commandId + 1 | 0));
  var textCopied = Clipboard$SmartcutsMacros.ClipboardContent.getTextExn(clipboardContent);
  return {
          commandId: textFromCommand.commandId,
          commandInfo: textFromCommand.commandInfo,
          text: textCopied
        };
}

var TextFromCommand = {
  t_encode: t_encode,
  t_decode: t_decode,
  stringify: stringify,
  applyClipboard: applyClipboard
};

function t_encode$1(v) {
  return Js_dict.fromArray([
              [
                "commandId",
                Decco.intToJson(v.commandId)
              ],
              [
                "text",
                Decco.stringToJson(v.text)
              ]
            ]);
}

function t_decode$1(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var commandId = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "commandId"), null));
  if (commandId.TAG === /* Ok */0) {
    var text = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "text"), null));
    if (text.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                commandId: commandId._0,
                text: text._0
              }
            };
    }
    var e = text._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".text" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = commandId._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".commandId" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function stringify$1(v) {
  return JSON.stringify(v);
}

var TextFromGSheetUpsertCommand = {
  t_encode: t_encode$1,
  t_decode: t_decode$1,
  stringify: stringify$1
};

function t_encode$2(v) {
  return Js_dict.fromArray([
              [
                "commandId",
                Decco.intToJson(v.commandId)
              ],
              [
                "commandInfo",
                v.commandInfo
              ],
              [
                "selection",
                Selection__StrictSelection$SmartcutsMacros.ForNonRecording.t_encode(v.selection)
              ],
              [
                "context",
                CommandContext$SmartcutsMacros.CommandContextGlobalResolved.t_encode(v.context)
              ]
            ]);
}

function t_decode$2(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var commandId = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "commandId"), null));
  if (commandId.TAG === /* Ok */0) {
    var commandInfo = {
      TAG: /* Ok */0,
      _0: Belt_Option.getWithDefault(Js_dict.get(dict$1, "commandInfo"), null)
    };
    if (commandInfo.TAG === /* Ok */0) {
      var selection = Selection__StrictSelection$SmartcutsMacros.ForNonRecording.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "selection"), null));
      if (selection.TAG === /* Ok */0) {
        var context = CommandContext$SmartcutsMacros.CommandContextGlobalResolved.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "context"), null));
        if (context.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    commandId: commandId._0,
                    commandInfo: commandInfo._0,
                    selection: selection._0,
                    context: context._0
                  }
                };
        }
        var e = context._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".context" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = selection._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".selection" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = commandInfo._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".commandInfo" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = commandId._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".commandId" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

var TextFromPageElement = {
  t_encode: t_encode$2,
  t_decode: t_decode$2
};

function t_encode$3(v) {
  return Js_dict.fromArray([
              [
                "commandId",
                Decco.intToJson(v.commandId)
              ],
              [
                "commandIndex",
                Decco.intToJson(v.commandIndex)
              ],
              [
                "url",
                Decco.stringToJson(v.url)
              ]
            ]);
}

function t_decode$3(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var commandId = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "commandId"), null));
  if (commandId.TAG === /* Ok */0) {
    var commandIndex = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "commandIndex"), null));
    if (commandIndex.TAG === /* Ok */0) {
      var url = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "url"), null));
      if (url.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  commandId: commandId._0,
                  commandIndex: commandIndex._0,
                  url: url._0
                }
              };
      }
      var e = url._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".url" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = commandIndex._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".commandIndex" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = commandId._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".commandId" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function stringify$2(param) {
  return "{commandIndex: " + (String(param.commandIndex) + (", url: " + (param.url + "}")));
}

var TextFromUrl = {
  t_encode: t_encode$3,
  t_decode: t_decode$3,
  stringify: stringify$2
};

function t_encode$4(v) {
  if (v.TAG === /* Text */0) {
    return [
            "Text",
            Decco.stringToJson(v._0)
          ];
  } else {
    return [
            "Var",
            Decco.stringToJson(v._0)
          ];
  }
}

function t_decode$4(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "Text" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Text */0,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "Var" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Var */1,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var TemplateComponent = {
  t_encode: t_encode$4,
  t_decode: t_decode$4
};

function image_encode(v) {
  if (typeof v === "number") {
    return ["NotResolved"];
  } else if (v.TAG === /* Base64Encoded */0) {
    return [
            "Base64Encoded",
            Decco.stringToJson(v._0),
            Image$SmartcutsMacros.Metadata.t_encode(v._1)
          ];
  } else {
    return [
            "BlobObject",
            Decco.stringToJson(v._0),
            Image$SmartcutsMacros.Metadata.t_encode(v._1)
          ];
  }
}

function image_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "Base64Encoded" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$1 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          var match$2 = Image$SmartcutsMacros.Metadata.t_decode(Belt_Array.getExn(jsonArr$1, 2));
          if (match$1.TAG === /* Ok */0) {
            if (match$2.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* Base64Encoded */0,
                        _0: match$1._0,
                        _1: match$2._0
                      }
                    };
            }
            var e = match$2._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e.path,
                      message: e.message,
                      value: e.value
                    }
                  };
          }
          var e$1 = match$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "BlobObject" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$3 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          var match$4 = Image$SmartcutsMacros.Metadata.t_decode(Belt_Array.getExn(jsonArr$1, 2));
          if (match$3.TAG === /* Ok */0) {
            if (match$4.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* BlobObject */1,
                        _0: match$3._0,
                        _1: match$4._0
                      }
                    };
            }
            var e$2 = match$4._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$2.path,
                      message: e$2.message,
                      value: e$2.value
                    }
                  };
          }
          var e$3 = match$3._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
      case "NotResolved" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* NotResolved */0
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function t_encode$5(v) {
  return Js_dict.fromArray([
              [
                "commandId",
                Decco.intToJson(v.commandId)
              ],
              [
                "image",
                image_encode(v.image)
              ]
            ]);
}

function t_decode$5(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var commandId = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "commandId"), null));
  if (commandId.TAG === /* Ok */0) {
    var image = image_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "image"), null));
    if (image.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                commandId: commandId._0,
                image: image._0
              }
            };
    }
    var e = image._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".image" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = commandId._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".commandId" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

var ImageFromCommand = {
  t_encode: t_encode$5,
  t_decode: t_decode$5,
  image_encode: image_encode,
  image_decode: image_decode
};

var DataRef = Caml_module.init_mod([
      "DataDependency.re",
      169,
      4
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "t_encode"
        ],
        [
          /* Function */0,
          "t_decode"
        ],
        [
          /* Function */0,
          "isTextFromGSheetUpsertCommand"
        ],
        [
          /* Function */0,
          "humanize"
        ],
        [
          /* Function */0,
          "humanizeWithConcreteValue"
        ],
        [
          /* Function */0,
          "resolveAsText"
        ],
        [
          /* Function */0,
          "toStaticText"
        ],
        [
          /* Function */0,
          "compareRawSnapshotAndCalcUpdate"
        ],
        [
          /* Function */0,
          "adjustAnyPasteToReferenceLastCopyCommand"
        ],
        [
          /* Function */0,
          "getReferencedCommandIds"
        ],
        [
          /* Function */0,
          "stringify"
        ],
        [
          /* Function */0,
          "toReactElement"
        ],
        [
          /* Function */0,
          "valueForFormInput"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "factorOutDynamicVars"
              ],
              [
                /* Function */0,
                "substituteInDynamicVars"
              ]
            ]
          },
          "Pack"
        ]
      ]
    });

function t_encode$6(v) {
  return Js_dict.fromArray([
              [
                "components",
                Decco.arrayToJson(t_encode$4, v.components)
              ],
              [
                "vars",
                CustomMap$SmartcutsMacros.MapStringWithDeccoSupport.t_encode(DataRef.t_encode, v.vars)
              ]
            ]);
}

function t_decode$6(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var components = Decco.arrayFromJson(t_decode$4, Belt_Option.getWithDefault(Js_dict.get(dict$1, "components"), null));
  if (components.TAG === /* Ok */0) {
    var vars = CustomMap$SmartcutsMacros.MapStringWithDeccoSupport.t_decode(DataRef.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "vars"), null));
    if (vars.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                components: components._0,
                vars: vars._0
              }
            };
    }
    var e = vars._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".vars" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = components._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".components" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

var empty_components = [];

var empty = {
  components: empty_components,
  vars: undefined
};

function appendText(text, template) {
  return {
          components: $$Array.append(template.components, [{
                  TAG: /* Text */0,
                  _0: text
                }]),
          vars: template.vars
        };
}

function appendVar(value, param) {
  var uuid = Uuid.v1();
  return {
          components: $$Array.append(param.components, [{
                  TAG: /* Var */1,
                  _0: uuid
                }]),
          vars: Belt_MapString.set(param.vars, uuid, value)
        };
}

function getReferencedCommandIds(param) {
  var arg = Belt_MapString.valuesToArray(param.vars);
  var param$1 = DataRef.getReferencedCommandIds;
  return ArrayUtils$SmartcutsMacros.mapcat(param$1, arg);
}

var Template = {
  t_encode: t_encode$6,
  t_decode: t_decode$6,
  empty: empty,
  appendText: appendText,
  appendVar: appendVar,
  getReferencedCommandIds: getReferencedCommandIds
};

function t_encode$7(v) {
  switch (v.TAG | 0) {
    case /* StaticText */0 :
        return [
                "StaticText",
                Decco.stringToJson(v._0)
              ];
    case /* PasteText */1 :
        return [
                "PasteText",
                Decco.stringToJson(v._0)
              ];
    case /* TextFromCommand */2 :
        return [
                "TextFromCommand",
                t_encode(v._0)
              ];
    case /* TextFromGSheetUpsertCommand */3 :
        return [
                "TextFromGSheetUpsertCommand",
                t_encode$1(v._0)
              ];
    case /* TextFromPageElement */4 :
        return [
                "TextFromPageElement",
                t_encode$2(v._0)
              ];
    case /* TextFromUrl */5 :
        return [
                "TextFromUrl",
                t_encode$3(v._0)
              ];
    case /* Template */6 :
        return [
                "Template",
                t_encode$6(v._0)
              ];
    case /* ImageFromCommand */7 :
        return [
                "ImageFromCommand",
                t_encode$5(v._0)
              ];
    
  }
}

function t_decode$7(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "ImageFromCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = t_decode$5(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* ImageFromCommand */7,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "PasteText" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* PasteText */1,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "StaticText" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$2 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$2.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* StaticText */0,
                      _0: v0$2._0
                    }
                  };
          }
          var e$2 = v0$2._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      case "Template" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$3 = t_decode$6(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$3.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Template */6,
                      _0: v0$3._0
                    }
                  };
          }
          var e$3 = v0$3._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
      case "TextFromCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$4 = t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$4.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* TextFromCommand */2,
                      _0: v0$4._0
                    }
                  };
          }
          var e$4 = v0$4._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$4.path,
                    message: e$4.message,
                    value: e$4.value
                  }
                };
      case "TextFromGSheetUpsertCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$5 = t_decode$1(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$5.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* TextFromGSheetUpsertCommand */3,
                      _0: v0$5._0
                    }
                  };
          }
          var e$5 = v0$5._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$5.path,
                    message: e$5.message,
                    value: e$5.value
                  }
                };
      case "TextFromPageElement" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$6 = t_decode$2(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$6.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* TextFromPageElement */4,
                      _0: v0$6._0
                    }
                  };
          }
          var e$6 = v0$6._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$6.path,
                    message: e$6.message,
                    value: e$6.value
                  }
                };
      case "TextFromUrl" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$7 = t_decode$3(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$7.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* TextFromUrl */5,
                      _0: v0$7._0
                    }
                  };
          }
          var e$7 = v0$7._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$7.path,
                    message: e$7.message,
                    value: e$7.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function isTextFromGSheetUpsertCommand(dataRef) {
  if (dataRef.TAG === /* TextFromGSheetUpsertCommand */3) {
    return true;
  } else {
    return false;
  }
}

function humanize(dataDep) {
  switch (dataDep.TAG | 0) {
    case /* StaticText */0 :
    case /* PasteText */1 :
        return StringUtils$SmartcutsMacros.quote(dataDep._0);
    case /* TextFromCommand */2 :
        return "the text copied in step " + String(dataDep._0.commandId + 1 | 0);
    case /* TextFromGSheetUpsertCommand */3 :
        return "the row inserted into the Google Sheet in step " + String(dataDep._0.commandId + 1 | 0);
    case /* TextFromUrl */5 :
        return "the url of the tab in step " + String(dataDep._0.commandIndex + 1 | 0);
    case /* TextFromPageElement */4 :
    case /* Template */6 :
        return "TODO";
    case /* ImageFromCommand */7 :
        return "the image copied in step " + String(dataDep._0.commandId + 1 | 0);
    
  }
}

function humanizeWithConcreteValue(dataDep) {
  switch (dataDep.TAG | 0) {
    case /* StaticText */0 :
    case /* PasteText */1 :
        return StringUtils$SmartcutsMacros.quote(dataDep._0);
    case /* TextFromCommand */2 :
        var match = dataDep._0;
        return "the text copied in step " + (String(match.commandId + 1 | 0) + (" (during your recording, the text was " + (StringUtils$SmartcutsMacros.quote(match.text) + ", but could be different when you run the smartcut in the future)")));
    case /* TextFromGSheetUpsertCommand */3 :
        var match$1 = dataDep._0;
        return "the row inserted into the Google Sheet in step " + (String(match$1.commandId + 1 | 0) + (" (during your recording, the inserted row added the cell value " + (StringUtils$SmartcutsMacros.quote(match$1.text) + ")")));
    case /* TextFromUrl */5 :
        var match$2 = dataDep._0;
        return "the url of the tab in step " + (String(match$2.commandIndex + 1 | 0) + (" (during your recording, the url was " + (StringUtils$SmartcutsMacros.quote(match$2.url) + ", but could be different when you run the smartcut in the future)")));
    case /* TextFromPageElement */4 :
    case /* Template */6 :
        return "TODO";
    case /* ImageFromCommand */7 :
        return "the image copied in step " + String(dataDep._0.commandId + 1 | 0);
    
  }
}

function resolveAsText(dataRef) {
  switch (dataRef.TAG | 0) {
    case /* StaticText */0 :
    case /* PasteText */1 :
        return dataRef._0;
    case /* TextFromCommand */2 :
        return dataRef._0.text;
    case /* TextFromGSheetUpsertCommand */3 :
        return dataRef._0.text;
    case /* TextFromUrl */5 :
        return dataRef._0.url;
    case /* TextFromPageElement */4 :
    case /* Template */6 :
        return "TODO";
    case /* ImageFromCommand */7 :
        return Util$SmartcutsMacros.logAndRaiseJsError("Not expect to resolveAsText for ImageFromCommand");
    
  }
}

function toStaticText(dataRef) {
  return {
          TAG: /* StaticText */0,
          _0: resolveAsText(dataRef)
        };
}

function compareRawSnapshotAndCalcUpdate(maybePaste, dataRef1, dataRef2) {
  if (maybePaste === undefined) {
    return ;
  }
  if (dataRef1.TAG !== /* StaticText */0) {
    return [
            dataRef2,
            false
          ];
  }
  var textBefore = dataRef1._0;
  if (textBefore === "") {
    if (dataRef2.TAG !== /* StaticText */0) {
      return [
              dataRef2,
              false
            ];
    }
    if (dataRef2._0 === maybePaste) {
      return [
              {
                TAG: /* PasteText */1,
                _0: maybePaste
              },
              true
            ];
    }
    
  }
  if (dataRef2.TAG !== /* StaticText */0) {
    return [
            dataRef2,
            false
          ];
  }
  var textAfter = dataRef2._0;
  var match = TextEditing$SmartcutsMacros.calcStringTransformation(undefined, undefined, textBefore, textAfter);
  if (typeof match === "number") {
    return ;
  }
  switch (match.TAG | 0) {
    case /* ReplaceText */0 :
        if (match._1.replaceWith === maybePaste) {
          return [
                  {
                    TAG: /* Template */6,
                    _0: appendText(match._2, appendVar({
                              TAG: /* PasteText */1,
                              _0: maybePaste
                            }, appendText(match._0, empty)))
                  },
                  true
                ];
        } else {
          return [
                  dataRef2,
                  false
                ];
        }
    case /* DeleteText */1 :
        return ;
    case /* InsertText */2 :
        var insertedText = match._1;
        if (insertedText === maybePaste) {
          return [
                  {
                    TAG: /* Template */6,
                    _0: appendText(match._2, appendVar({
                              TAG: /* PasteText */1,
                              _0: insertedText
                            }, appendText(match._0, empty)))
                  },
                  true
                ];
        } else {
          return [
                  dataRef2,
                  false
                ];
        }
    
  }
}

function adjustAnyPasteToReferenceLastCopyCommand(lastCopyInfo, dataRef) {
  switch (dataRef.TAG | 0) {
    case /* PasteText */1 :
        var text = dataRef._0;
        if (lastCopyInfo === undefined) {
          return {
                  TAG: /* PasteText */1,
                  _0: text
                };
        }
        var lastCopiedText = lastCopyInfo[1];
        if (lastCopiedText === text) {
          return {
                  TAG: /* TextFromCommand */2,
                  _0: {
                    commandId: lastCopyInfo[0],
                    commandInfo: null,
                    text: lastCopiedText
                  }
                };
        } else {
          return {
                  TAG: /* PasteText */1,
                  _0: text
                };
        }
    case /* ImageFromCommand */7 :
        return Util$SmartcutsMacros.logAndRaiseJsError("Expected text variants of DataRef here");
    default:
      return dataRef;
  }
}

function getReferencedCommandIds$1(dataRef) {
  switch (dataRef.TAG | 0) {
    case /* StaticText */0 :
    case /* PasteText */1 :
        return [];
    case /* Template */6 :
        return getReferencedCommandIds(dataRef._0);
    default:
      return [dataRef._0.commandId];
  }
}

function stringify$3(dataRef) {
  switch (dataRef.TAG | 0) {
    case /* StaticText */0 :
        return "StaticText(" + (dataRef._0 + ")");
    case /* PasteText */1 :
        return "PasteText(" + (dataRef._0 + ")");
    case /* TextFromCommand */2 :
        return "TextFromCommand(" + (stringify(dataRef._0) + ")");
    case /* TextFromGSheetUpsertCommand */3 :
        return "TextFromGSheetUpsertCommand(" + (JSON.stringify(dataRef._0) + ")");
    case /* TextFromPageElement */4 :
        return "TextFromPageElement(_)";
    case /* TextFromUrl */5 :
        return "TextFromUrl(" + (stringify$2(dataRef._0) + ")");
    case /* Template */6 :
        return "Template(_)";
    case /* ImageFromCommand */7 :
        return "ImageFromCommand(_)";
    
  }
}

function staticTextToReactElements(s) {
  var index = s.search(RegExUtils$SmartcutsMacros.newLineRe);
  if (index !== -1) {
    return $$Array.append([
                $$String.sub(s, 0, index),
                React.createElement("br", undefined)
              ], staticTextToReactElements(s.slice(index + 1 | 0)));
  } else {
    return [s];
  }
}

function toReactElement(dataRef) {
  var commandRef = function (commandId) {
    return React.createElement(React.Fragment, undefined, ReactUtils$SmartcutsMacros.s("from command (id="), React.createElement("b", undefined, ReactUtils$SmartcutsMacros.s(String(commandId))), ReactUtils$SmartcutsMacros.s(")"));
  };
  switch (dataRef.TAG | 0) {
    case /* StaticText */0 :
    case /* PasteText */1 :
        return staticTextToReactElements(dataRef._0);
    case /* TextFromCommand */2 :
        return staticTextToReactElements(dataRef._0.text);
    case /* TextFromGSheetUpsertCommand */3 :
        return staticTextToReactElements(dataRef._0.text);
    case /* TextFromUrl */5 :
        return staticTextToReactElements(dataRef._0.url);
    case /* TextFromPageElement */4 :
    case /* Template */6 :
        return ReactUtils$SmartcutsMacros.s("TODO");
    case /* ImageFromCommand */7 :
        var match = dataRef._0;
        var image = match.image;
        var tmp;
        if (typeof image === "number") {
          tmp = ReactUtils$SmartcutsMacros.s("Not resolved");
        } else if (image.TAG === /* Base64Encoded */0) {
          var mimeType = Image$SmartcutsMacros.Format.mimeType(image._1.format);
          tmp = React.createElement("img", {
                src: "data:" + (mimeType + (";base64," + image._0))
              });
        } else {
          tmp = React.createElement("img", {
                src: image._0
              });
        }
        return React.createElement("div", undefined, ReactUtils$SmartcutsMacros.s("Image "), commandRef(match.commandId), tmp);
    
  }
}

function valueForFormInput(dataRef) {
  switch (dataRef.TAG | 0) {
    case /* StaticText */0 :
    case /* PasteText */1 :
        return dataRef._0;
    default:
      return Util$SmartcutsMacros.logAndRaiseJsError("Unimplemented form input value for non static text");
  }
}

function factorOutDynamicVars(dataRef) {
  var vars;
  switch (dataRef.TAG | 0) {
    case /* StaticText */0 :
    case /* PasteText */1 :
        vars = [dataRef._0];
        break;
    case /* TextFromCommand */2 :
        var match = dataRef._0;
        vars = [
          match.commandId,
          match.commandInfo,
          match.text
        ];
        break;
    case /* TextFromGSheetUpsertCommand */3 :
        var match$1 = dataRef._0;
        vars = [
          match$1.commandId,
          match$1.text
        ];
        break;
    case /* TextFromPageElement */4 :
        vars = [dataRef._0.commandInfo];
        break;
    default:
      vars = [];
  }
  var factoredValue;
  switch (dataRef.TAG | 0) {
    case /* StaticText */0 :
        factoredValue = {
          TAG: /* StaticText */0,
          _0: ""
        };
        break;
    case /* PasteText */1 :
        factoredValue = {
          TAG: /* PasteText */1,
          _0: ""
        };
        break;
    case /* TextFromCommand */2 :
        factoredValue = {
          TAG: /* TextFromCommand */2,
          _0: {
            commandId: -1,
            commandInfo: null,
            text: ""
          }
        };
        break;
    case /* TextFromGSheetUpsertCommand */3 :
        factoredValue = {
          TAG: /* TextFromGSheetUpsertCommand */3,
          _0: {
            commandId: -1,
            text: ""
          }
        };
        break;
    case /* TextFromPageElement */4 :
        var inner = dataRef._0;
        factoredValue = {
          TAG: /* TextFromPageElement */4,
          _0: {
            commandId: inner.commandId,
            commandInfo: null,
            selection: inner.selection,
            context: inner.context
          }
        };
        break;
    default:
      factoredValue = dataRef;
  }
  return {
          vars: vars,
          factoredValue: factoredValue
        };
}

function substituteInDynamicVars(param) {
  var factoredDataRef = param.factoredValue;
  var vars = param.vars;
  switch (factoredDataRef.TAG | 0) {
    case /* StaticText */0 :
    case /* PasteText */1 :
        break;
    case /* TextFromCommand */2 :
        var arg = Js_json.decodeNumber(Caml_array.get(vars, 0));
        var arg$1 = Js_json.decodeString(Caml_array.get(vars, 2));
        return {
                TAG: /* TextFromCommand */2,
                _0: {
                  commandId: (function (param) {
                        return OptionUtils$SmartcutsMacros.getExn(param, arg);
                      })("Expected var to be a string") | 0,
                  commandInfo: Caml_array.get(vars, 1),
                  text: (function (param) {
                        return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
                      })("Expected var to be a string")
                }
              };
    case /* TextFromGSheetUpsertCommand */3 :
        var arg$2 = Js_json.decodeNumber(Caml_array.get(vars, 0));
        var arg$3 = Js_json.decodeString(Caml_array.get(vars, 1));
        return {
                TAG: /* TextFromGSheetUpsertCommand */3,
                _0: {
                  commandId: (function (param) {
                        return OptionUtils$SmartcutsMacros.getExn(param, arg$2);
                      })("Expected var to be a string") | 0,
                  text: (function (param) {
                        return OptionUtils$SmartcutsMacros.getExn(param, arg$3);
                      })("Expected var to be a string")
                }
              };
    case /* TextFromPageElement */4 :
        var inner = factoredDataRef._0;
        return {
                TAG: /* TextFromPageElement */4,
                _0: {
                  commandId: inner.commandId,
                  commandInfo: Caml_array.get(vars, 0),
                  selection: inner.selection,
                  context: inner.context
                }
              };
    default:
      return factoredDataRef;
  }
  var arg$4 = Js_json.decodeString(Caml_array.get(vars, 0));
  var s = (function (param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg$4);
      })("Expected var to be a string");
  return {
          TAG: /* StaticText */0,
          _0: s
        };
}

var Pack = {
  factorOutDynamicVars: factorOutDynamicVars,
  substituteInDynamicVars: substituteInDynamicVars
};

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "t_encode"
        ],
        [
          /* Function */0,
          "t_decode"
        ],
        [
          /* Function */0,
          "isTextFromGSheetUpsertCommand"
        ],
        [
          /* Function */0,
          "humanize"
        ],
        [
          /* Function */0,
          "humanizeWithConcreteValue"
        ],
        [
          /* Function */0,
          "resolveAsText"
        ],
        [
          /* Function */0,
          "toStaticText"
        ],
        [
          /* Function */0,
          "compareRawSnapshotAndCalcUpdate"
        ],
        [
          /* Function */0,
          "adjustAnyPasteToReferenceLastCopyCommand"
        ],
        [
          /* Function */0,
          "getReferencedCommandIds"
        ],
        [
          /* Function */0,
          "stringify"
        ],
        [
          /* Function */0,
          "toReactElement"
        ],
        [
          /* Function */0,
          "valueForFormInput"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "factorOutDynamicVars"
              ],
              [
                /* Function */0,
                "substituteInDynamicVars"
              ]
            ]
          },
          "Pack"
        ]
      ]
    }, DataRef, {
      t_encode: t_encode$7,
      t_decode: t_decode$7,
      isTextFromGSheetUpsertCommand: isTextFromGSheetUpsertCommand,
      humanize: humanize,
      humanizeWithConcreteValue: humanizeWithConcreteValue,
      resolveAsText: resolveAsText,
      toStaticText: toStaticText,
      compareRawSnapshotAndCalcUpdate: compareRawSnapshotAndCalcUpdate,
      adjustAnyPasteToReferenceLastCopyCommand: adjustAnyPasteToReferenceLastCopyCommand,
      getReferencedCommandIds: getReferencedCommandIds$1,
      stringify: stringify$3,
      toReactElement: toReactElement,
      valueForFormInput: valueForFormInput,
      Pack: Pack
    });

exports.TextFromCommand = TextFromCommand;
exports.TextFromGSheetUpsertCommand = TextFromGSheetUpsertCommand;
exports.TextFromPageElement = TextFromPageElement;
exports.TextFromUrl = TextFromUrl;
exports.TemplateComponent = TemplateComponent;
exports.ImageFromCommand = ImageFromCommand;
exports.DataRef = DataRef;
exports.Template = Template;
/* DataRef Not a pure module */
